import BricksError from './BricksError';

export default BricksError;
